/**
 * Shared interfaces, types, and default configurations for the SensitiveFileInput feature.
 *
 * This file serves as the platform-agnostic contract consumed by both the
 * web and mobile component implementations.
 */

export const AUTO_HIDE_SECONDS = 30
export interface IProtectedViewConfig {
  title?: string // e.g., "Protected Information"
  subtitle?: string // e.g., "This image contains PII. Access is logged..."
  submitText?: string // e.g., "View Document"
}

export interface IAccessReasonConfig {
  title?: string // e.g., "Access Reason Required"
  text?: string // e.g., "Please provide a reason for viewing..."
  placeholder?: string // e.g., "E.g., Verifying identity..."
  confirmText?: string // e.g., "Submit & View"
}

export interface IAccessDeniedConfig {
  title?: string // e.g., "Access Failed"
  retryText?: string // e.g., "Retry"
  cancelText?: string // e.g., "Cancel"
}

export interface ISensitiveFileInputProps {
  label?: string
  emptyText?: string
  value?: any
  frames?: any

  protectedCfg?: IProtectedViewConfig
  reasonCfg?: IAccessReasonConfig
  deniedCfg?: IAccessDeniedConfig
}

export const defaultProtectedConfig: IProtectedViewConfig = {
  title: 'Protected Information',
  subtitle: 'This image contains PII. Access is logged and restricted.',
  submitText: 'View Document',
}

export const defaultReasonConfig: IAccessReasonConfig = {
  title: 'Access Reason Required',
  text: 'Please provide a reason for viewing this driver’s license. This action will be logged.',
  placeholder: 'E.g., Verifying driver identity for shipment #12345',
  confirmText: 'Submit & View',
}

export const defaultDeniedConfig: IAccessDeniedConfig = {
  title: 'Access Failed',
  retryText: 'Retry',
  cancelText: 'Cancel',
}
